export default function DwsLogoFooter() {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="267"
         height="65"
         fill="none"
         viewBox="0 0 267 65"
      >
         <path
            fill="#E41C5C"
            d="M147.521 43.017l-3.43-9.376-3.431 9.377a3.483 3.483 0 002.237 4.613c.299.15.746.15 1.044.15h.299c.298 0 .746-.15 1.044-.15 1.939-.595 2.834-2.679 2.237-4.614z"
         ></path>
         <path
            fill="#4E5C66"
            d="M47.88 20.246c0 1.935-1.491 3.572-3.58 3.572-1.938 0-3.58-1.637-3.58-3.572s1.492-3.572 3.58-3.572c1.94.149 3.58 1.637 3.58 3.572zM80.845 20.246c0 1.935-1.491 3.572-3.58 3.572-1.939 0-3.58-1.637-3.58-3.572s1.492-3.572 3.58-3.572c1.94.149 3.58 1.637 3.58 3.572zM246.416 26.05c-2.834 0-5.072.595-6.713 1.637-1.491 1.042-2.386 2.828-2.386 5.507 0 2.084.597 3.572 1.79 4.465 1.193.893 2.983 1.34 5.37 1.638 1.79.148 2.983.446 3.58.744.596.446.894.893.894 1.786 0 1.042-.298 1.786-.894 2.084-.597.297-1.641.446-3.282.446-2.237 0-4.326-.298-6.265-1.042l-1.044 4.019c2.088.744 4.624 1.19 7.607 1.19 2.984 0 5.221-.595 6.713-1.637 1.491-1.042 2.386-2.828 2.386-5.507 0-2.083-.596-3.572-1.641-4.465-1.193-.893-2.983-1.488-5.668-1.786-1.79-.149-2.834-.446-3.431-.744-.596-.298-.894-.893-.894-1.637 0-1.042.298-1.637.894-1.935.597-.298 1.492-.447 2.984-.447 2.088 0 4.027.298 6.115 1.042l1.194-4.018c-2.536-.893-4.774-1.34-7.309-1.34zM227.92 47.78V33.045c0-.744.447-1.34 1.342-1.786.895-.446 2.088-.595 3.431-.595.895 0 1.79.149 2.685.298V26.05c-.746-.149-1.492-.149-2.238-.149-2.685 0-4.475.744-5.37 2.233v-1.637h-5.22V47.78h5.37zm-14.171-16.818c.597.595.895 1.786 1.044 3.572h-8.949c.149-1.786.596-2.977 1.193-3.572.597-.596 1.79-.893 3.431-.893 1.64 0 2.685.297 3.281.893zm-2.535 13.097c-1.94 0-3.431-.297-4.177-1.041-.895-.745-1.193-2.233-1.342-4.317h13.722c.15-2.53 0-4.614-.298-6.25-.298-1.638-.895-2.978-1.641-3.87-.745-.894-1.79-1.638-2.834-1.936-1.193-.297-2.536-.595-4.325-.595-3.282 0-5.669.893-7.309 2.53-1.641 1.638-2.536 4.614-2.536 8.633 0 4.167.895 6.995 2.685 8.632 1.79 1.638 4.325 2.53 7.607 2.53 2.536 0 5.072-.446 7.309-1.19l-.895-4.019a19.97 19.97 0 01-5.966.893zM189.883 26.05c-2.834 0-5.071.595-6.712 1.637-1.492 1.042-2.387 2.828-2.387 5.507 0 2.084.597 3.572 1.79 4.465 1.194.893 2.984 1.34 5.37 1.638 1.79.148 2.983.446 3.58.744.597.446.895.893.895 1.786 0 1.042-.298 1.786-.895 2.084-.597.297-1.641.446-3.132.446-2.238 0-4.326-.298-6.265-1.042l-1.044 4.019c2.088.744 4.624 1.19 7.607 1.19 2.983 0 5.221-.595 6.712-1.637 1.492-1.042 2.387-2.828 2.387-5.507 0-2.083-.597-3.572-1.641-4.465-1.193-.893-2.983-1.488-5.668-1.786-1.79-.149-2.834-.446-3.431-.744-.596-.298-.895-.893-.895-1.637 0-1.042.299-1.637.895-1.935.597-.298 1.492-.447 2.984-.447 2.088 0 4.027.298 6.115 1.042l1.193-4.018c-2.684-.893-4.922-1.34-7.458-1.34zm-17.601 21.73h5.221V26.645h-5.221V47.78zM122.76 17.864v24.26c0 2.828.746 5.06 2.238 6.698l4.475-1.935c-1.044-1.488-1.641-3.125-1.641-4.911V17.864h-5.072zm-13.275 26.642c-1.641 0-2.685-.149-3.132-.596-.448-.446-.746-1.339-.746-2.679 0-1.34.298-2.083.746-2.53.596-.297 1.64-.595 3.132-.595 1.641 0 2.983.149 4.177.446v5.21c-1.343.446-2.685.744-4.177.744zm7.011-16.67c-1.492-1.19-3.729-1.786-7.011-1.786-2.834 0-5.668.447-8.353 1.19l.895 4.168c1.939-.744 4.027-1.042 6.414-1.042 2.237 0 3.58.298 4.326.893.596.596 1.044 1.786 1.044 3.721a23.701 23.701 0 00-5.37-.595c-2.834 0-4.922.446-6.265 1.34-1.342.892-2.088 2.827-2.088 5.506 0 2.68.596 4.614 1.939 5.656 1.342 1.042 3.58 1.489 7.011 1.489 3.579 0 6.712-.596 9.546-1.638V34.236c0-2.977-.746-5.21-2.088-6.4zm-18.795-1.19h-7.01V20.99l-5.072 2.083v3.572h-3.58v4.465h3.58v9.526c0 2.977.597 5.06 1.64 6.102 1.045 1.042 2.835 1.638 5.37 1.638 2.089 0 4.028-.298 5.818-.893l-.895-4.168c-1.193.447-2.387.596-3.58.596s-2.088-.298-2.536-.894c-.447-.595-.745-1.488-.745-2.827v-9.08h7.01v-4.465zM74.283 47.78h5.22V26.645h-5.22V47.78zm-11.038 3.126c-1.044.744-2.536 1.042-4.624 1.042-2.089 0-4.177-.298-6.414-1.042l-1.044 4.167c2.237.893 4.624 1.191 7.458 1.191 1.79 0 3.281-.149 4.624-.447 1.342-.297 2.386-.744 3.58-1.488 1.044-.744 1.79-1.786 2.386-3.126.448-1.339.746-3.125.746-5.06V27.687c-2.536-1.042-5.668-1.637-9.248-1.637-3.58 0-6.265.893-7.756 2.53-1.641 1.638-2.387 4.614-2.387 8.782 0 4.167.746 6.995 2.088 8.632 1.492 1.637 3.73 2.382 6.713 2.382 2.088 0 3.878-.447 5.37-1.34.149 1.786-.448 3.126-1.492 3.87zm.298-7.59c-.746.297-1.79.594-2.983.594-1.79 0-3.133-.446-3.73-1.339-.596-.893-1.043-2.68-1.043-5.21 0-2.976.298-4.762 1.044-5.655.596-.893 1.939-1.34 3.878-1.34 1.492 0 2.834.298 4.027.744v10.717c.15.595-.298 1.19-1.193 1.488zM41.766 47.78h5.22V26.645h-5.22V47.78zm-11.337-8.93c-.596 1.488-1.491 2.53-2.685 3.126-1.193.595-2.983.744-5.37.744h-5.37V21.734h5.37c1.79 0 3.282.149 4.326.297 1.044.15 1.94.745 2.685 1.489.746.744 1.193 1.786 1.492 3.125.298 1.34.447 3.126.447 5.507 0 2.977-.298 5.21-.895 6.698zm-19.39 8.93h11.783c5.071 0 8.8-1.19 11.187-3.423 2.387-2.381 3.43-6.4 3.43-12.205 0-2.976-.298-5.507-.894-7.442-.597-1.934-1.492-3.572-2.834-4.762-1.194-1.191-2.834-1.935-4.475-2.382-1.79-.446-3.878-.744-6.414-.744H11.038V47.78z"
         ></path>
         <path
            fill="#001F8E"
            d="M177.652 7.744c0 1.935-1.641 3.572-3.58 3.572s-3.58-1.637-3.58-3.572 1.641-3.572 3.58-3.572c2.088 0 3.58 1.637 3.58 3.572z"
         ></path>
         <path
            fill="url(#paint0_linear_5957_1353)"
            d="M140.213 17.567c0 1.934 1.492 3.423 3.431 3.423s3.58-1.637 3.58-3.572-1.641-3.572-3.58-3.572c-1.939.149-3.431 1.786-3.431 3.72z"
         ></path>
         <path
            fill="url(#paint1_linear_5957_1353)"
            d="M154.979 13.398c0 1.935 1.641 3.572 3.58 3.572s3.58-1.637 3.58-3.572-1.641-3.572-3.58-3.572c-1.939.149-3.58 1.637-3.58 3.572z"
         ></path>
         <path
            fill="url(#paint2_linear_5957_1353)"
            d="M154.681 25.604l-3.431 9.377 3.729 10.12a3.41 3.41 0 01.149-2.083l3.431-9.525-3.729-10.419c-.298-.893-1.044-1.637-1.79-2.084 1.492 1.042 2.387 2.977 1.641 4.614z"
         ></path>
         <path
            fill="url(#paint3_linear_5957_1353)"
            d="M135.588 20.84c-1.939.744-2.834 2.828-2.237 4.614l7.309 19.944c.447 1.489 1.79 2.382 3.281 2.382-.298 0-.746-.15-1.044-.15-1.939-.743-2.834-2.827-2.237-4.613l3.43-9.377-3.878-10.567c-.596-1.489-1.939-2.382-3.431-2.382-.447 0-.745 0-1.193.15z"
         ></path>
         <path
            fill="url(#paint4_linear_5957_1353)"
            d="M147.82 23.073l-3.879 10.418 3.431 9.377a3.483 3.483 0 01-2.237 4.614c-.299.149-.746.149-1.044.149 1.491 0 2.834-.893 3.281-2.381l3.729-10.419-3.431-9.377a3.485 3.485 0 012.238-4.614c.895-.297 1.939-.297 2.685.15-.149 0-.149-.15-.299-.15-.447-.149-.894-.149-1.193-.149-1.342 0-2.685.893-3.281 2.382z"
         ></path>
         <path
            fill="#930078"
            d="M152.891 21.138c-.149 0-.149 0-.149-.15-.895-.297-1.79-.446-2.685-.148-1.939.744-2.834 2.828-2.238 4.614l3.431 9.377 3.431-9.377c.746-1.488-.149-3.423-1.79-4.316z"
         ></path>
         <path
            fill="url(#paint5_linear_5957_1353)"
            d="M164.525 16.971l-5.966 16.67 3.43 9.526c.299.744.299 1.34.149 2.083l9.398-25.748a3.485 3.485 0 00-2.238-4.614c-.447-.15-.895-.15-1.193-.15-1.641-.148-2.983.745-3.58 2.233z"
         ></path>
         <path
            fill="#3B0086"
            d="M161.989 43.166l-3.43-9.525-3.431 9.525c-.298.745-.298 1.34-.149 2.084l.149.447c.597 1.488 1.939 2.381 3.431 2.381 1.491 0 2.834-.893 3.43-2.381l.15-.447c.149-.744.149-1.488-.15-2.084z"
         ></path>
         <defs>
            <linearGradient
               id="paint0_linear_5957_1353"
               x1="140.185"
               x2="147.219"
               y1="17.519"
               y2="17.519"
               gradientUnits="userSpaceOnUse"
            >
               <stop stopColor="#EC6B59"></stop>
               <stop offset="0.018" stopColor="#EC6B59"></stop>
               <stop offset="0.21" stopColor="#EB6359"></stop>
               <stop offset="0.509" stopColor="#E94D5A"></stop>
               <stop offset="0.875" stopColor="#E5295C"></stop>
               <stop offset="0.993" stopColor="#E41C5C"></stop>
               <stop offset="1" stopColor="#E41C5C"></stop>
            </linearGradient>
            <linearGradient
               id="paint1_linear_5957_1353"
               x1="155.022"
               x2="162.055"
               y1="13.46"
               y2="13.46"
               gradientUnits="userSpaceOnUse"
            >
               <stop stopColor="#930078"></stop>
               <stop offset="0.001" stopColor="#930078"></stop>
               <stop offset="1" stopColor="#3B0086"></stop>
            </linearGradient>
            <linearGradient
               id="paint2_linear_5957_1353"
               x1="151.312"
               x2="158.55"
               y1="33.159"
               y2="33.159"
               gradientUnits="userSpaceOnUse"
            >
               <stop stopColor="#930078"></stop>
               <stop offset="0.001" stopColor="#930078"></stop>
               <stop offset="1" stopColor="#3B0086"></stop>
            </linearGradient>
            <linearGradient
               id="paint3_linear_5957_1353"
               x1="133.148"
               x2="144.054"
               y1="34.293"
               y2="34.293"
               gradientUnits="userSpaceOnUse"
            >
               <stop stopColor="#EC6B59"></stop>
               <stop offset="0.018" stopColor="#EC6B59"></stop>
               <stop offset="0.26" stopColor="#EC6859"></stop>
               <stop offset="0.471" stopColor="#EB5D5A"></stop>
               <stop offset="0.67" stopColor="#E94B5A"></stop>
               <stop offset="0.862" stopColor="#E6325B"></stop>
               <stop offset="0.993" stopColor="#E41C5C"></stop>
               <stop offset="1" stopColor="#E41C5C"></stop>
            </linearGradient>
            <linearGradient
               id="paint4_linear_5957_1353"
               x1="148.425"
               x2="148.425"
               y1="47.914"
               y2="20.749"
               gradientUnits="userSpaceOnUse"
            >
               <stop stopColor="#E41C5C"></stop>
               <stop offset="1" stopColor="#930078"></stop>
            </linearGradient>
            <linearGradient
               id="paint5_linear_5957_1353"
               x1="156.885"
               x2="171.884"
               y1="42.134"
               y2="16.206"
               gradientUnits="userSpaceOnUse"
            >
               <stop stopColor="#3B0086"></stop>
               <stop offset="0.237" stopColor="#360387"></stop>
               <stop offset="0.535" stopColor="#260B89"></stop>
               <stop offset="0.862" stopColor="#0D188C"></stop>
               <stop offset="0.999" stopColor="#001F8E"></stop>
               <stop offset="1" stopColor="#001F8E"></stop>
            </linearGradient>
         </defs>
      </svg>
   )
}